import React from 'react';

import {convertParamsForVersionsQuery} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/utils';
import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {useInfiniteListFetcherRTK} from 'app/general/datafetchers/hooks/useInfiniteListFetcherRTK';
import {useProcessVersions} from 'app/process/api';

import type {LeftSidebarPanelType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  ProcessHashidSerializedType,
  ProcessVersionSerializedType,
} from 'sweet-types';

const VersionsSidebarComponent =
  VersionsSidebarFactory<ProcessVersionSerializedType>();
export function ProcessVersionsPanelContent({
  object,
  version,
}: LeftSidebarPanelType<ProcessHashidSerializedType>) {
  const {
    results: versions,
    refetch,
    loadNext,
    hasNext,
  } = useInfiniteListFetcherRTK({
    fetchParams: {
      objectId: object.id,
    },
    useDataHook: useProcessVersions,
    paramsConverter: convertParamsForVersionsQuery,
  });
  return (
    <VersionsSidebarComponent
      object={object}
      selectedVersion={version}
      loadVersions={async () => refetch()}
      loadMoreVersions={async () => loadNext()}
      moreToLoad={hasNext}
      versions={versions}
    />
  );
}
